export default function() {
    return {
        template: {
            variables: [],
            whatsappTemplate: null
        },
        success: false,
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["image", "link"]],
        errors: {
            subject: null,
            content: null
        },
        whatsappTemplates: []
    }
}
